import React, { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from "react-router";
import { BASE_API } from '../../api/Globals';
import { helpHttp } from '../../helpers/helpHttp';
import { Dialog } from 'primereact/dialog';
import { Steps } from 'primereact/steps';
import { Button } from 'primereact/button';
import Menu from '../../components/sturtural/Menu';
import Loader from '../../components/sturtural/Loader';
import InputUpload from "../../components/sturtural/InputUpload";
import PendientesContext from '../../context/PendientesContext';
import Scanner from '../../components/sturtural/Scanner';
import TallaCalzado from '../../components/sturtural/TallaCalzado';
import BusquedaAPata from '../../components/sturtural/BusquedaAPata';
import { Tooltip } from 'primereact/tooltip';
import { LABELTEXT } from '../../api/Globals';
import { ProgressSpinner } from 'primereact/progressspinner';
import AuthContext from '../../context/AuthContext';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { DataView } from 'primereact/dataview';
import { Toast } from 'primereact/toast';
import { storage } from '../../helpers/storage';

const initialFormTutor = {
    IdTutor: null,
    nombre: "",
    apellido1: "",
    apellido2: "",
    idTipoTutor: null,
}

const validationsFrom_NuevoTutor = (data) => {
    let errors = {};
    let regexName = /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s]+$/;

    if (!data.nombre.trim()) {
        errors.nombre = "El campo (nombre) es requerido";
    } else
        if (!regexName.test(data.nombre.trim())) {
            errors.nombre = "El campo (nombre) no acepta números ni caracteres especiales";
        }

    if (!data.apellido1.trim()) {
        errors.apellido1 = "El campo (primer apellido) es requerido";
    } else if (!regexName.test(data.apellido1.trim())) {
        errors.apellido1 = "El campo (primer apellido) no acepta números ni caracteres especiales";
    }

    if (data.apellido2.trim()) {
        if (!regexName.test(data.apellido2.trim())) {
            errors.apellido2 = "El campo (segundo apellido) no acepta números ni caracteres especiales";
        }
    }
    if (data.idTipoTutor === null) {
        errors.idTipoTuor = "El campo (tipo tutor) es requerido";
    }

    return errors;
}


const MultientregaScanner = () => {

    const navigate = useNavigate();
    const { name, nameTipoUsuario, nameCiclo } = useContext(AuthContext);
    const [formTutor, setFormTutor] = useState(initialFormTutor)
    const [errors_nuevo_tutor, setErrors_NuevoTutor] = useState(true);
    const [lstTipoTutor, setLstTipoTutor] = useState([]);
    const perfilid = storage.get('perfilid');

    const { pendientes } = useContext(PendientesContext);


    const init = {
        "IdEncEntrega": 0,
        "IdEncEntregaArray": [... new Set(pendientes.map(item => item.IdEncEntrega))], //pendientes.map(alumno => alumno.IdEncEntrega) //unique si son iguales
        "DetEntrega": [],
        "IdUsuario": storage.get('id'),
        "FotoFrente": "",
        "FotoReverso": "",
        "FotoComprobante": "",
        "FotoFirma": "",
        "lstArchivos": [],
        "FechaModificacion": "",
        "IdTutorSeleccionado": "",
        "IdAlumno": 0,
        "IdEstatus": 2,
        "IdMotivoCancelacion": 0,
        "OtroMotivoCancelacion": "",
        "IdAlumnosArray": pendientes.map(alumno => alumno.IdAlumno),
        "JustificacionDeCancelacion": "",
        "IdTipoDocumento": 1,
        "IdDocumento": 1,
        "JustificacionDeCancelacion": "",
        "IsEntrega": true
    }

    const [menusa, setMenusa] = useState(true);
    const [formTalla, setFormTalla] = useState(true);
    const [formIndentificacion, setFormIdentificacion] = useState(false);
    const [formFirma, setFormFirma] = useState(false);
    //const [formTutor, setFormTutor] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [displayConfirmation, setDisplayConfirmation] = useState(false);
    const [confirm_cancelar, setConfirm_cancelar] = useState(false);
    const [aviso, setAviso] = useState(false);
    const [message, setMessage] = useState(null);
    const [avisoe, setAvisoe] = useState(false);
    const [messagee, setMessagee] = useState(null);
    const [guardadoExitoso, setGuardadoExitoso] = useState(null);

    const [load_alumno, setLoad_alumno] = useState(false);
    const [frontal, setFrontal] = useState(null);
    const [reverso, setReverso] = useState(null);
    const [comprobante, setComprobante] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingEditarTutor, setLoadingEditarTutor] = useState(false);
    const [resumen, setResumen] = useState(false);
    const [drawing, setDrawing] = useState(false);
    const [documentos, setDocumentos] = useState([])
    const [canntidadEvidencias, setCantidadEvidencias] = useState(storage.get('ciclo').tipoDocumento)


    const [displayDialogMensaje, setDisplayDialogMensaje] = useState(false);

    const [confirmScanner, setConfirmScanner] = useState(false);

    const [alumno, setAlumno] = useState(null);
    const [prenda, setPrenda] = useState([]);
    const [envio, setEnvio] = useState(init);
    const [tutores, setTutores] = useState([]);
    const [confirmarFinalizar, setConfirmarFinalizar] = useState(false);

    const [actualizar, setActualizar] = useState([]);
    const [editarTutor, setEditarTutor] = useState(false);
    const [prendaConsulta, setPrendaConsulta] = useState([])

    const canvasRef = useRef(null);
    const ctxRef = useRef(null);

    const ciclo = storage.get('ciclo');
    const idUsuario = storage.get("id")
    const idTienda = storage.get("IdTienda")
    const cantidadEvidencias = ciclo.CantidadEvidencias
    const toast = useRef(null);

    useEffect(() => {
        if (pendientes.length === 0) {
            navigate('/pendientes');
        } else {
            consultarPrendas([... new Map(pendientes.map(x => { return JSON.parse(x.PrendaElegida).map(j => { return { idNivel: x.IdNivel, idPrenda: j.IdPrenda, idGenero: x.IdGenero } }) }).flat(1).map(obj => [`${obj.idNivel}:${obj.idPrenda}:${obj.idGenero}`, obj])).values()])
        }
    }, [pendientes]);

    // useEffect(() => {
    //     if (envio.DetEntrega.length > 0) {
    //         if (envio.IdTutorSeleccionado === "") {
    //             var detEntrega = envio.DetEntrega;
    //             var idAlumnosArray = envio.IdAlumnosArray;
    //             var entregasPorIdAlumno = contarEntregasPorIdAlumno(detEntrega);
    //             var todosTienenTresEntregas = verificarTresEntregasPorIdAlumno(idAlumnosArray, entregasPorIdAlumno);

    //             console.log(todosTienenTresEntregas)
    //             if (todosTienenTresEntregas === false) {
    //                 setDisplayDialogMensaje(true)
    //             }
    //         }
    //     }
    // }, [envio])

    const consultarPrendas = async (arrPrendas) => {
        let url = `${BASE_API}Prendas/CargarCatalogo`;
        const consultaPrendas = await Promise.all(arrPrendas.map(async (x) => {
            const arrSet2 = {
                "IdGenero": x.idGenero,
                "IdNivel": x.idNivel,
                "IdPrenda": x.idPrenda,
                "IdCicloEscolar": ciclo.IdCicloEscolar
            };
            return await helpHttp().post(url, {
                body: arrSet2,
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Access-Control-Allow-Origin': '*',
                    'Authorization': `Bearer ${storage.get('token')}`
                },
            }).then(res => {
                if (res.ITEMS1 !== null) {
                    return res
                }
            })
        }))
        setPrendaConsulta(consultaPrendas.flat(1))
    }

    const getTipoTutor = () => {
        helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                opcion: 0,
                sp: "SpdGetTipoTutor",
                parametros: []
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                setLstTipoTutor(res.ITEMS)
            }
        })
    }

    const handleChange_Tutor = (e) => {
        const { name, value } = e.target;
        setFormTutor({
            ...formTutor,
            [name]: value,
        });
    };

    const wizardItems = [
        {
            label: 'Prendas',
            command: () => redirects(true, false, false)
        },
        {
            label: 'Identificación',
            command: () => redirects(false, true, false)
        },
    ];

    const redirects = (talla, identificacion, firma) => {
        setFormTalla(talla);
        setFormIdentificacion(identificacion);
        setFormFirma(firma);
    }

    const handlerRedirect = () => {
        if (resumen) {
            var IdAlumnosArray = envio.IdAlumnosArray[0];
            window.location.href = `#/resumen/${window.btoa(IdAlumnosArray)}`;
        } else {
            setMessage(null);
            setAviso(false)
        }
    }

    const handleClick_siguienteIdentificacion = () => {
        if (frontal && reverso && comprobante) {
            setActiveIndex(2);
            setFormTalla(false);
            setFormIdentificacion(false);
            setFormFirma(true);

            document.body.style.overflow = "hidden";
        } else {
            setMessage('Favor de cargar las imágenes de su identificación.');
            setAviso(true);
        }
    }

    const contarEntregasPorIdAlumno = (detEntrega) => {
        var entregasPorIdAlumno = {};
        var entregasPorIdAlumno2 = {};
        let Alumnos = pendientes.map(alumno => alumno.IdAlumno)

        Alumnos.forEach(IdAlumno => {
            detEntrega.forEach(prenda => {
                if (IdAlumno === prenda.IdAlumno) {
                    if (prenda.Prenda === undefined && prenda.Talla === undefined) {
                        entregasPorIdAlumno2[IdAlumno] = 0
                    }
                    else {
                        if (entregasPorIdAlumno2[IdAlumno] === undefined) {
                            entregasPorIdAlumno2[IdAlumno] = 1
                        } else {
                            entregasPorIdAlumno2[IdAlumno]++
                        }
                    }
                } else {
                    if (entregasPorIdAlumno2[IdAlumno] === undefined) {
                        entregasPorIdAlumno2[IdAlumno] = 0
                    }

                }

            })
        })

        // console.log(entregasPorIdAlumno2)

        // for (var i = 0; i < detEntrega.length; i++) {
        //     var idAlumno = detEntrega[i].IdAlumno;
        //     if (entregasPorIdAlumno[idAlumno] === undefined) {
        //         entregasPorIdAlumno[idAlumno] = 1;
        //     } else {
        //         entregasPorIdAlumno[idAlumno]++;
        //     }
        // }
        return entregasPorIdAlumno2;
    }

    // Función para verificar que todos los IdAlumnos tengan exactamente tres entregas
    const verificarTresEntregasPorIdAlumno = (idAlumnosArray, entregasPorIdAlumno) => {
        for (var j = 0; j < idAlumnosArray.length; j++) {
            var idAlumno = idAlumnosArray[j];
            if (entregasPorIdAlumno[idAlumno] < ciclo.LimitePrendas) {
                return false;
            }
        }
        return true;
    }

    const validarDocumentosObligatorios = (config, documentos) => {
        if (!Array.isArray(config) || !Array.isArray(documentos)) {
            return false;
        }

        const idsObligatorios = config
            .filter(doc => doc.obligatorio)
            .map(doc => doc.IdTipoDocumento);

        const idsPresentes = documentos.map(doc => doc.idTipoDocumento);

        return idsObligatorios.every(id => idsPresentes.includes(id));
    }

    const handleConfirmarFinalizar = () => {
        if (validarDocumentosObligatorios(canntidadEvidencias, envio.lstArchivos?.map(x => { return { idTipoDocumento: x.idTipoDocumento } }))) {
            setFormTalla(false);
            setFormIdentificacion(true);
            setFormFirma(false);

            // document.body.style.overflow = "hidden";
            setConfirmarFinalizar(true);

        } else {
            setMessage('Favor de cargar la evidencia.');
            setAviso(true);
        }
    }

    const handleSubmit_finalizar_qr = () => {

        var detEntrega = envio.DetEntrega;
        var idAlumnosArray = envio.IdAlumnosArray;

        var entregasPorIdAlumno = contarEntregasPorIdAlumno(detEntrega);
        var todosTienenTresEntregas = verificarTresEntregasPorIdAlumno(idAlumnosArray, entregasPorIdAlumno);
        if (todosTienenTresEntregas) {
            setMenusa(false);


            setLoading(true);
            helpHttp().post(`${BASE_API}Entrega/ConfirmarEntrega`, {
                body: { ...envio, IdCicloEscolar: ciclo.IdCicloEscolar },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Access-Control-Allow-Origin': '*',
                    'Authorization': `Bearer ${storage.get('token')}`
                },
            }).then((res) => {
                setConfirmarFinalizar(false);
                if (res.SUCCESS === true) {
                    setMessage(res.MESSAGE);
                    console.log('res.MESSAGE', res)
                    setGuardadoExitoso(res.SUCCESS)
                    setResumen(true);
                    setAviso(true);
                } else if (res.SUCCESS === false) {
                    setMessage('(Error: 022) Error de conexión, favor de iniciar el proceso nuevamente.');
                    setAviso(true);
                } else {
                    setMessage('(Error: 021) Ocurrió un error al intentar realizar este proceso.');
                    setAviso(true);
                }

                setMenusa(true);
                setLoading(false);
            });
        } else {
            alert("No se cumple la validación: Al menos un alumno no tiene prendas a entregar1.");
        }
    }

    const handlerCancelarRedirect = () => {
        localStorage.removeItem('transactionIdAlumno');
        localStorage.removeItem('transactionIdEntrega');
        localStorage.removeItem('transactionTallas');
        //localStorage.removeItem('transactionNames');
        localStorage.removeItem('transactionFolio');

        navigate('/pendientes');
    }

    const confirmationDialogFooter = (
        <>
            <div className="flex pt-3">
                <div className="w-6 pr-2">
                    <button className="p-button p-component p-button-outlined p-button-secondary w-full p-button-icon-only" onClick={() => setConfirm_cancelar(false)}>
                        <span className="p-button-icon p-c pi pi-times-circle">&nbsp;NO</span>
                        <span className="p-button-label p-c">&nbsp;</span>
                    </button>
                </div>
                <div className="w-6 pl-2">
                    <button className="p-button p-component p-button-outlined p-button-secondary w-full p-button-icon-only" onClick={() => handlerCancelarRedirect()}>
                        <span className="p-button-icon p-c pi pi-check-circle">&nbsp;SI</span>
                        <span className="p-button-label p-c">&nbsp;</span>
                    </button>
                </div>
            </div>
        </>
    );

    const handleSelectionFrontal = base64 => {
        setFrontal(base64);

        setEnvio(prevState => ({
            ...prevState,
            FotoFrente: base64.split(',')[1]
        }));
    }

    const handleSeleccionReverso = base64 => {
        setReverso(base64);

        setEnvio(prevState => ({
            ...prevState,
            FotoFirma: base64.split(',')[1]
        }));
    }

    const handleSeleccionComprobante = base64 => {
        setComprobante(base64);

        setEnvio(prevState => ({
            ...prevState,
            FotoComprobante: base64.split(',')[1]
        }));
    }

    const handleSeleccionArchivos = (idTipoDocumento, base64) => {

        setDocumentos(prevState => [
            ...prevState.filter(archivo => archivo.idTipoDocumento !== idTipoDocumento),
            { idTipoDocumento: idTipoDocumento, Documento: base64 }
        ])

        setEnvio(prevState => ({
            ...prevState,
            lstArchivos: [
                ...prevState.lstArchivos.filter(archivo => archivo.idTipoDocumento !== idTipoDocumento),
                { idTipoDocumento: idTipoDocumento, Documento: base64.split(',')[1], RutaComponente: '' }
            ]
        }))
    }

    useEffect(() => {

    }, [actualizar])

    // useEffect(() => {
    //     if (formFirma) {
    //         document.body.style.overflow = 'hidden';
    //         let width = window.innerWidth - 90;

    //         const canvas = canvasRef.current;
    //         // For supporting computers with higher screen densities, we double the screen density
    //         canvas.width = width * 2;
    //         canvas.height = 300 * 2;

    //         canvas.style.width = `${width}px`;
    //         canvas.style.height = `300px`;
    //         // Setting the context to enable us draw
    //         const ctx = canvas.getContext('2d');
    //         ctx.scale(2, 2);
    //         ctx.lineCap = 'round';
    //         ctx.strokeStyle = 'blue';
    //         ctx.lineWidth = 2;
    //         ctx.shadowBlur = 2 / 1;
    //         ctxRef.current = ctx;


    //         //no se mueva al firmar
    //         ctxRef.current.clearRect(
    //             0,
    //             0,
    //             canvasRef.current.width,
    //             canvasRef.current.height
    //         );
    //         ctx.beginPath();
    //         //


    //     }
    // }, [formFirma]);

    const getPositionOnCanvas = (event) => {
        const clientX = event.clientX || event.touches[0].clientX;
        const clientY = event.clientY || event.touches[0].clientY;
        const canvasX = clientX;
        const canvasY = clientY;
        const posicion = canvasRef.current.getBoundingClientRect();
        const nuevaPosicionX = canvasX - posicion.x;
        const nuevaPosicionY = canvasY - posicion.y;

        return { x: nuevaPosicionX, y: nuevaPosicionY };
    }

    const startDraw = ({ nativeEvent }) => {
        const position = getPositionOnCanvas(nativeEvent);
        //const { offsetX, offsetY } = nativeEvent;
        ctxRef.current.beginPath();
        ctxRef.current.moveTo(position.x, position.y);
        setDrawing(true);
    };

    const stopDraw = () => {
        ctxRef.current.closePath();
        setDrawing(false);
    };

    const draw = ({ nativeEvent }) => {
        if (drawing) {
            const position = getPositionOnCanvas(nativeEvent);
            ctxRef.current.lineTo(position.x, position.y);
            ctxRef.current.stroke();
        }
    };

    const clear = () => {
        ctxRef.current.clearRect(
            0,
            0,
            canvasRef.current.width,
            canvasRef.current.height
        );
    };

    const getFirmaB64 = () => {
        return canvasRef.current?.toDataURL();
    }

    const firmaValida = () => {
        let firma = canvasRef.current?.getContext('2d').getImageData(0, 0, canvasRef.current.width, canvasRef.current.height).data.some(channel => channel !== 0);

        setEnvio(prevState => ({
            ...prevState,
            FotoFirma: getFirmaB64().split(',')[1]
        }));

        return firma;
    }

    const basicDialogFooter = <Button type="button" label="Aceptar" onClick={() => handlerRedirect(false)} icon="pi pi-check" className="p-button ml-3" />;

    const basicDialogFooterMensaje = <Button type="button" label="Aceptar" onClick={() => setDisplayDialogMensaje(!displayDialogMensaje)} className="p-button" />;

    const basicDialogFooter2 = <Button type="button" label="Aceptar2" onClick={() => console.log('')} icon="pi pi-check" className="p-button-secondary" />;

    const mensajeOmicion = () => {
        setMessage("Favor de firmar digitalmente.");
        setAviso(true);
    }

    function sustituir(selection, envio) {
        var replace = [];
        replace = envio.DetEntrega.filter((x) => x.Prenda === undefined);
        if (replace.length > 0) {
            for (let i = 0; i < envio.DetEntrega.length; i++) {
                if (envio.DetEntrega[i].Prenda === undefined) {
                    envio.DetEntrega[i] = selection
                    setActualizar(selection)
                    break;
                }
            }
        }
    }

    const confirmationCancelarDialogFooter = (
        <>
            <div className="flex pt-3">
                <div className="w-6 pr-2">
                    <button className="p-button p-component p-button-outlined p-button-secondary w-full p-button-icon-only" onClick={() => setConfirm_cancelar(false)}>
                        <span className="p-button-icon p-c pi pi-times-circle">&nbsp;NO</span>
                        <span className="p-button-label p-c">&nbsp;</span>
                    </button>
                </div>
                <div className="w-6 pl-2">
                    <button className="p-button p-component p-button-outlined p-button-secondary w-full p-button-icon-only" onClick={() => handlerCancelarRedirect()}>
                        <span className="p-button-icon p-c pi pi-check-circle">&nbsp;SI</span>
                        <span className="p-button-label p-c">&nbsp;</span>
                    </button>
                </div>
            </div>
        </>
    );

    const confirmationFinalizarDialogFooter = (
        //estandares de botones ---------
        <>
            <div className="surface-border pt-3">
                <Button type="button" label="No" onClick={() => setConfirmarFinalizar(false)} icon="pi pi-times" className="p-button-outlined ml-3" />
                <Button icon={(loading ? 'pi pi-spin pi-spinner' : 'pi pi-check')} disabled={loading} type="button" label="Sí" onClick={() => handleSubmit_finalizar_qr()} className="p-button ml-3" />
            </div>
        </>
    );

    const handleScanner = (alumno) => {
        setAlumno(alumno);
        setConfirmScanner(true);
    }

    const campoTutorVacio = (IdTutorSeleccionado, lstTutores) => {
        return lstTutores.some(
            x => x.IdTutor === IdTutorSeleccionado && x.NombreCompletoTutor.trim().length > 0
        );
    }

    const detalleYaExiste = (detalle) => {
        return envio.DetEntrega.some(
            det => JSON.stringify(det) === JSON.stringify(detalle)
        );
    };

    const detalleYaExisteTipoPrenda = (detalle) => {
        return envio.DetEntrega.some(
            item => item.IdPrenda === detalle.IdPrenda && item.IdAlumno === detalle.IdAlumno
        );
    };

    const idAlumnoYaExiste = (id) => {
        return envio.IdAlumnosArray.includes(id);
    };

    const idEntregaYaExiste = (id) => {
        return envio.IdEncEntregaArray.includes(id);
    };

    const detalleYaExisteOtroAlumno = (detalle) => {
        if (detalle.IdPrenda != 10) {
            return envio.DetEntrega.some(
                det => det.SerieEntregado === detalle.SerieEntregado
            );
        } else {
            return false;
        }
    };

    const handlePrenda = (arrPrenda, selection, IdAlumno, IdEncEntrega) => {
        if (selection !== null) {
            if (!detalleYaExisteOtroAlumno(selection)) {
                if (!detalleYaExiste(selection) && !detalleYaExisteTipoPrenda(selection)) {
                    if (!idAlumnoYaExiste(IdAlumno) && !idEntregaYaExiste(IdEncEntrega)) {
                        //var newIdAlumnosArray = [...envio.IdAlumnosArray, IdAlumno];
                        //var newIdEncEntregaArray = [...envio.IdEncEntregaArray, IdEncEntrega];
                        setEnvio(prevState => ({
                            ...prevState,
                            DetEntrega: [...prevState.DetEntrega, selection],
                            //IdEncEntregaArray: newIdEncEntregaArray,
                            // IdAlumnosArray: newIdAlumnosArray
                        }));
                    } else {
                        if (envio.DetEntrega.length < 3) {
                            setEnvio(prevState => ({
                                ...prevState,
                                DetEntrega: [...prevState.DetEntrega, selection],
                            }));
                        } else {
                            sustituir(selection, envio)
                        }

                    }
                    //setPrenda([...prenda, arrPrenda]);
                } else {
                    // alert('YA SELECCIONASTE ESTA PRENDA O TIPO DE PRENDA');
                    //Se cambia la talla del calzado
                    envio.DetEntrega.map((pc, index) => {

                        if (pc.IdPrenda == selection.IdPrenda && pc.IdAlumno === IdAlumno) {
                            envio.DetEntrega[index] = selection
                            setActualizar(selection)
                        }
                    });
                }
            } else {
                // alert('YA SELECCIONASTE ESTA PRENDA PARA OTRO ALUMNO');
                if (envio.DetEntrega.length !== 0) {
                    if (!detalleYaExisteTipoPrenda(selection)) {
                        var replace = [];
                        replace = envio.DetEntrega.filter((x) => x.Prenda === undefined);
                        if (replace.length > 0) {
                            for (let i = 0; i < envio.DetEntrega.length; i++) {
                                if (envio.DetEntrega[i].Prenda === undefined) {
                                    envio.DetEntrega[i] = selection
                                    setActualizar(selection)
                                    break;
                                }
                            }
                        }
                        //  setEnvio(prevState => ({
                        //         ...prevState,
                        //         DetEntrega: [...prevState.DetEntrega, selection],
                        //         //IdEncEntregaArray: newIdEncEntregaArray,
                        //         // IdAlumnosArray: newIdAlumnosArray
                        //     }));

                    } else {
                        envio.DetEntrega.map((pc, index) => {

                            if (pc.IdPrenda == selection.IdPrenda && pc.IdAlumno === IdAlumno) {
                                envio.DetEntrega[index] = selection
                                setActualizar(selection)
                            }
                        });
                    }
                }
                if (envio.DetEntrega.length > 3) {
                    // setEnvio(prevState => ({
                    //     ...prevState,
                    //     DetEntrega: [...prevState.DetEntrega, selection],
                    //     //IdEncEntregaArray: newIdEncEntregaArray,
                    //     // IdAlumnosArray: newIdAlumnosArray
                    // }));
                } else {
                    //se cambia las talla de las prendas seleccionadas
                    envio.DetEntrega.map((pc, index) => {
                        if (pc.IdPrenda == selection.IdPrenda && pc.IdAlumno === IdAlumno) {
                            envio.DetEntrega[index] = selection
                            setActualizar(selection)
                        }

                    });
                }


                prendaXalumno(IdAlumno)
            }
            setConfirmScanner(false);
        }


    }

    const prendaXalumno = (id) => {

        var objetosConId = envio.DetEntrega.filter((objeto) => {
            return objeto.IdAlumno === id && objeto.Prenda !== undefined;
        });
        return (
            <>
                {objetosConId.length > 0 ? objetosConId.map((talla, x) =>
                    <li className="list-group-item d-flex justify-content-between align-items-center mb-2" key={`seleccionados-${x}`}>
                        <div>
                            <span className="text-900 font-medium mr-2 mb-1 md:mb-0">{talla.Prenda} {talla.Talla}</span>
                            <small className="mt-1 text-600">SERIE: {talla.SerieEntregado} {talla.borrado}</small>
                        </div>
                        {/* {(talla.borrado && <i role="button" onClick={() => eliminarPorPropiedades(talla)} className="pi pi-times-circle text-green-500 mr-2"/>)} */}
                    </li>) :
                    <ProgressSpinner />
                }
            </>
        )
    }

    const verificarEvidencias = async (ciclo) => {
        const response = await helpHttp().post(`${BASE_API}Usuarios/SpdRptCicloEscolar`, {
            body: {
                TipoPerfil: perfilid
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        })

        const consultaCiclo = response?.ITEMS.find(x => x.IdCicloEscolar === ciclo.IdCicloEscolar);

        if (!consultaCiclo) {
            console.warn("No se encontró ciclo especificado.")
            return JSON.parse(ciclo.tipoDocumento)
        }

        return consultaCiclo.tipoDocumento !== ciclo.tipoDoumento
            ? JSON.parse(consultaCiclo.tipoDocumento)
            : JSON.parse(ciclo.tipoDocumento)

    }

    const handleCapturaIdentificacion = async () => {

        var detEntrega = envio.DetEntrega;
        var idAlumnosArray = envio.IdAlumnosArray;
        var entregasPorIdAlumno = contarEntregasPorIdAlumno(detEntrega);
        var todosTienenTresEntregas = verificarTresEntregasPorIdAlumno(idAlumnosArray, entregasPorIdAlumno);
        var tieneCamposVacios = campoTutorVacio(envio.IdTutorSeleccionado, tutores);
        var cantidadEvidencias = await verificarEvidencias(ciclo);

        // if (detEntrega.length > 0) {
        if (todosTienenTresEntregas) {
            if (envio.IdTutorSeleccionado > 0) {
                if (tieneCamposVacios) {
                    helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
                        body: {
                            sp: "SpdAgregarMovimientoUsuario",
                            tipo: 2,
                            parametros: [
                                { IdUsuario: idUsuario },
                                { IdTienda: idTienda },
                                { IdEtapa: 2 },
                                { IdEncEntrega: JSON.stringify(envio.IdEncEntregaArray) },
                                { IdAlumno: JSON.stringify(envio.IdAlumnosArray) },
                                { IdCicloEscolar: ciclo.IdCicloEscolar },
                                { ParametrosExtra: "" },
                            ]
                        },
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            "Accept": "application/json",
                            'Authorization': `Bearer ${storage.get('token')}`
                        }
                    }).then(response => {
                        if (response.SUCCESS) {
                            if (response.ITEMS.ErrorNumber === 0) {
                                setCantidadEvidencias(cantidadEvidencias)
                                setActiveIndex(1);
                                setFormTalla(false);
                                setFormIdentificacion(true);
                                setFormFirma(false);
                            } else {
                                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Fallo en conexión, intente de nuevo.", life: 3000 });
                            }
                        } else {
                            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Fallo en conexión, intente de nuevo.", life: 3000 });
                        }
                    }).catch(error => {
                        console.warn(error);
                        toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Fallo en conexión, intente de nuevo.", life: 3000 });
                    })

                } else {
                    setAviso(true);
                    setMessage("Nombre de tutor vacío, favor de ingresar nombre.");
                }
            } else {
                setAviso(true);
                setMessage("Entrega múltiple: Debe seleccionar el tutor al que se le está entregando las prendas");
            }
        } else {
            setAviso(true);
            setMessage("No se cumple la validación: Al menos un alumno no tiene prendas a entregar.");
        }
        // } else {
        //     alert("No ha seleccionado prendas");
        // }
    }

    const handleRegresarASeleccionPrenda = () => {
        setActiveIndex(0);
        setFormTalla(true);
        setFormIdentificacion(false);
        setFormFirma(false);
    }

    const handleRegresarACargarComprobante = () => {
        setActiveIndex(1);
        setFormTalla(false);
        setFormIdentificacion(true);
        setFormFirma(false);
    }

    const handleRegresarAPendientes = () => {
        setActiveIndex(0);
        navigate('/pendientes');
    }

    useEffect(() => {
        const arrTutores = pendientes.map(alumno => alumno.ObjTutor);
        const unique = [... new Map(arrTutores.map(item =>
            [item["IdTutor"], item])).values()];
        if (pendientes.length > 1) {
            const arrTutores = pendientes.map(alumno => alumno.ObjTutor);
            const unique = [... new Map(arrTutores.map(item =>
                [item["IdTutor"], item])).values()];
            if (unique.length > 1) {
                setTutores(unique);
            } else {
                setEnvio(prevState => ({
                    ...prevState,
                    IdTutorSeleccionado: unique[0].IdTutor
                }));
                setTutores(unique)
            }
        } else {
            setTutores(unique);
            setEnvio(prevState => ({
                ...prevState,
                IdTutorSeleccionado: pendientes[0].IdTutor
            }));
        }
    }, [pendientes]);

    const handleSelectionTutorMultiple = (IdTutor) => {
        setEnvio(prevState => ({
            ...prevState,
            IdTutorSeleccionado: IdTutor
        }));
    }

    useEffect(() => {
    }, [envio]);

    useEffect(() => {

    }, [prenda]);

    const eliminarPorPropiedades = (talla) => {
        /*var propiedades = {
            "IdPrenda": talla.IdPrenda,
            "IdAlumno": talla.IdAlumno
        };

        var newPrenda = prenda.filter(detalle => {
            for (const key in propiedades) {
                if (detalle[key] !== propiedades[key]) {
                    return true;
                }
            }
            return false;
        });*/

        //setPrenda(newPrenda);

        eliminarPrendaPorIdAlumno(talla.IdAlumno, talla.IdPrenda);
    }

    const eliminarPrendaPorIdAlumno = (IdAlumno, IdPrenda) => {
        //var DetEntrega = envio.DetEntrega.filter(detalle => detalle.IdAlumno !== idAlumno && detalle.IdPrenda !== idPrenda);
        //var IdAlumnosArray = envio.DetEntrega.map(detalle => detalle.IdAlumno);
        //var IdEncEntregaArray = [...new Set(envio.DetEntrega.map(detalle => detalle.IdEncEntrega))]; // Elimina duplicados
        var propiedades = {
            "IdPrenda": IdPrenda,
            "IdAlumno": IdAlumno
        };

        var newPrenda = envio.DetEntrega.filter(detalle => {
            for (const key in propiedades) {
                if (parseInt(detalle[key]) !== parseInt(propiedades[key])) {
                    return true;
                }
            }
            return false;
        });

        setEnvio(prevState => ({
            ...prevState,
            DetEntrega: newPrenda
        }));
    }

    const modalonhiden2 = () => {
        setEditarTutor(false);
        setErrors_NuevoTutor(true);
        setFormTutor(initialFormTutor);
    }

    const handleEditarTutor = (tutor) => {
        helpHttp().post(`${BASE_API}Entrega/posSpdTutorActualizar`, {
            body: {
                opcion: 'S',
                IdTutor: tutor.IdTutor,
                ParametrosExtra: `[{"IdCicloEscolar": ${ciclo.IdCicloEscolar}}]`
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(async (res) => {
            if (res.SUCCESS) {
                setEditarTutor(true)
                // getTipoTutor()
                setFormTutor({
                    IdTutor: res.ITEMS.IdTutor,
                    nombre: res.ITEMS.Nombre,
                    apellido1: res.ITEMS.ApellidoPaterno,
                    apellido2: res.ITEMS.ApellidoMaterno,
                })
            }
        })
    }

    const handleConfirmarEditarTutor = (e) => {
        e.preventDefault()
        setLoadingEditarTutor(true);
        setErrors_NuevoTutor(validationsFrom_NuevoTutor(formTutor));
        if (Object.keys(validationsFrom_NuevoTutor(formTutor)).length === 0) {
            helpHttp().post(`${BASE_API}Entrega/posSpdTutorActualizar`, {
                body: {
                    opcion: "U",
                    IdTutor: formTutor.IdTutor,
                    Nombre: formTutor.nombre,
                    ApellidoPaterno: formTutor.apellido1,
                    ApellidoMaterno: formTutor.apellido2,
                    ParametrosExtra: `[{"IdCicloEscolar": ${ciclo.IdCicloEscolar} }]`
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if (res.SUCCESS) {
                    const actualizaTutores = tutores.map(x => {
                        if (x.IdTutor === formTutor.IdTutor) {
                            return {
                                ...x,
                                NombreCompletoTutor: (`${formTutor.nombre.trim()} ${formTutor.apellido1.trim()} ${formTutor.apellido2.trim()}`).trim()
                            };
                        } else {
                            return x;
                        }
                    })
                    setTutores(actualizaTutores);
                }
                setEditarTutor(false);
                setFormFirma(initialFormTutor);
                setLoadingEditarTutor(false);
            })
        } else {
            setLoadingEditarTutor(false);
        }
    }

    const EvidenciasTemplate = () => {
        return (
            <>
                {canntidadEvidencias.map((evidencia, i) => (
                    <div key={i} className="col-12 p-3">
                        <div className={`shadow-2 border-round surface-card mb-3 h-full flex-column justify-content-between flex`}>
                            <div className="p-4">
                                {evidencia.obligatorio && <div className='text-right' style={{ color: 'red' }}>* Campo obligatorio</div>}

                                <span className={`inline-flex border-circle align-items-center justify-content-center bg-gray-100 mr-3`} style={{ 'width': "48px", 'height': "48px", 'borderRadius': "10px" }}>
                                    <i className={`pi pi-camera text-xl text-gray-600`}></i>
                                </span>
                                <span className="text-900 font-medium text-2xl">
                                    {evidencia.obligatorio && <span style={{ color: 'red' }}>* </span>}{evidencia.TipoDocumento}
                                </span>
                            </div>

                            <div className='col-12'>
                                <img
                                    style={{ 'display': 'block', 'width': '100%', 'height': '100%' }}
                                    id='base64image'
                                    src={documentos.find(x => x.idTipoDocumento === evidencia.IdTipoDocumento)?.Documento || null}>
                                </img>
                            </div>

                            <div className="px-4 py-3 surface-100 text-right">
                                <div className="input-group">
                                    <InputUpload
                                        usuarioid={storage.get('id')}
                                        accept='image/*'
                                        handleSelection={value => handleSeleccionArchivos(evidencia.IdTipoDocumento, value)} />
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </>
        )
    }

    return (
        <>
            {menusa && <Menu link='nueva-solicitud' />}
            <Toast ref={toast} />
            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <h4 style={{ textAlign: 'center', marginBottom: '20px' }}>Entrega de {ciclo.proceso.toLowerCase()}</h4>
                        <Steps model={wizardItems} activeIndex={activeIndex} onSelect={(e) => setActiveIndex(e.index)} readOnly={true} /><br />
                    </div>
                </div>



                {formTalla &&
                    <div className="card col-12">
                        <div className="row">
                            <Tooltip target={`.custom-tooltip-iconAlumnoDisponible`}>
                                <div>Disponible</div>
                            </Tooltip>
                            <Tooltip target={`.custom-tooltip-iconAlumnoNoDisponible`}>
                                <div>No disponible</div>
                            </Tooltip>



                            {tutores.length > 0 &&
                                <div className="col-12">
                                    <div className="card col-12" style={{ border: 'none' }}>
                                        <div className="row">
                                            <div className="col-12 lg:col-6 md:col-6">
                                                <ul className="list-group">
                                                    <label style={{ fontWeight: '600', marginBottom: '15px' }}>Seleccionar tutor:</label>
                                                    {tutores.map((tutor, i) =>
                                                        <>
                                                            <Tooltip target=".custom-target-icon" />
                                                            <div className='custom-target-icon flex' data-pr-tooltip='Haga doble clic para editar' data-pr-position='top'>
                                                                <li id='listadoTutores' style={{ border: 'none', borderRadius: '15px', cursor: 'pointer' }} className={`list-group-item ${envio.IdTutorSeleccionado === tutor.IdTutor && 'active'}`} key={`tutor-${i}`} onClick={() => { envio.IdTutorSeleccionado === tutor.IdTutor ? handleEditarTutor(tutor) : handleSelectionTutorMultiple(tutor.IdTutor) }}>
                                                                    <i className='pi pi-pencil' style={{ marginRight: '10px' }}></i>
                                                                    {tutor.NombreCompletoTutor}
                                                                </li>
                                                            </div>
                                                        </>
                                                    )}
                                                </ul>
                                            </div>
                                            <div className='col-12 lg:col-6 md:col-6 text-center lg:text-right md:text-right sm:text-right align-content-center mt-1 pr-6'>
                                                <span style={{ fontSize: '14px', fontWeight: '600' }}>Total alumnos </span><span style={{ fontSize: '17px', fontWeight: '700' }}>{pendientes.length}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>}


                            {load_alumno ? <div><Loader /></div> :
                                pendientes.sort((a, b) => a.IdAlumno - b.IdAlumno) && pendientes.sort((a, b) => a.IdAlumno - b.IdAlumno).sort((a, b) => {

                                    let aPrendaElegida = JSON.parse(a.PrendaElegida);
                                    let bPrendaElegida = JSON.parse(b.PrendaElegida);

                                    if (aPrendaElegida.filter(prenda => prenda.PrendaDisponible === 1).length > bPrendaElegida.filter(prenda => prenda.PrendaDisponible === 1).length) {
                                        return 1;
                                    } else {
                                        return -1
                                    }
                                }).map((alumno, i) => {
                                    return <div className="lg:col-3 md:col-6 xs:col-12" key={`tarjeta-${i}`}>
                                        <div className="p-3 h-full">
                                            <div className="shadow-5 p-3 h-full flex flex-column surface-card" style={{ borderRadius: '15px' }}>
                                                <div className="flex mb-2"
                                                    style={{
                                                        marginLeft: '-14px',
                                                        marginRight: '-14px',
                                                        marginTop: '-14px',
                                                        borderTopLeftRadius: '15px',
                                                        borderTopRightRadius: '15px',
                                                        background: '#9b2f3e',
                                                        color: '#ffffff',
                                                        padding: '8px',
                                                        height: '63px',
                                                        paddingTop: 0,
                                                        paddingBottom: 0
                                                    }}>
                                                    <div className='col-1' style={{ alignSelf: 'center'/* , border: '1px solid #FFFFFF', borderRadius: '25px', width: '28px', height: '28px', paddingTop: '3px' */ }}><i className='pi pi-user' style={{ color: '#FFFFFF' }}></i></div>
                                                    <div className='col-11' style={{ paddingTop: 0, paddingBottom: 0, alignSelf: 'center' }}>
                                                        <label style={{ fontWeight: '700' }}>{alumno?.Folio}</label><br />
                                                        <label>{alumno?.Nombre} {alumno?.ApellidoPaterno} {alumno?.ApellidoMaterno}</label>
                                                    </div>
                                                </div>
                                                <div className="text-600" style={{ marginBottom: '22px', marginTop: '10px' }}>
                                                    <label style={{ color: '#9B2F3E', fontWeight: '500', fontWeight: '700', paddingTop: '5px', paddingBottom: '5px' }}>Información</label> <br />
                                                    Escuela: <span>{alumno?.CCT} ({alumno?.Nivel})</span><br />
                                                    Grado y grupo: <span>{alumno?.Grado} {alumno?.Grupo}</span></div>

                                                <div>
                                                    <label style={{ color: '#9B2F3E', fontWeight: '500', fontWeight: '700', paddingTop: '5px', paddingBottom: '5px' }}>Prendas</label> <br />

                                                    {/*     {JSON.parse(alumno.PrendaElegida).map((item, x) =>
                                                        <div key={`prenda-${x}`} className='col-12 flex' style={{padding: 0}}>
                                                            <div className='col-8' style={{padding: 0}}>
                                                                <label>{(item.Prenda)} </label>
                                                            </div>
                                                            <div className='col-3' style={{padding: 0}}>
                                                                <label>Talla <label style={item.Talla === '-' ? { fontWeight: 'bold' } : { fontWeight: 'normal' }}>{(item.Talla)}</label></label>
                                                            </div>
                                                            <div className='col-1' style={{padding: 0}}>
                                                                <div className={parseInt(item.PrendaDisponible) === 1 ? 'custom-tooltip-iconAlumnoDisponible' : 'custom-tooltip-iconAlumnoNoDisponible'} style={parseInt(item.PrendaDisponible) === 1 ? { marginLeft: '.5rem', color: '#008f39' } : { marginLeft: '.5rem', color: 'red' }}><i className={parseInt(item.PrendaDisponible) === 1 ? 'pi pi-check' : 'pi pi-times'} style={{ fontWeight: 'bold' }} /></div>
                                                            </div>
                                                        </div>
                                                    )} */}

                                                </div>

                                                <TallaCalzado alumno={alumno} handlePrenda={handlePrenda} prendaConsulta={prendaConsulta} valueT={(e) => { '' }} />

                                                {/* <hr className="my-3 mx-0 border-top-1 border-bottom-none surface-border" />
                                                <div className='grid'>
                                                    <div className='col-12'>
                                                        <div className='font-semibold text-s mb-2'>Prendas a entregar:</div>
                                                    </div>
                                                    <div className='col-12'>
                                                        <ul className="list-group">
                                                            {prendaXalumno(alumno.IdAlumno)}
                                                        </ul>
                                                    </div>
                                                </div> */}

                                                {/* <hr className="mb-3 mx-0 border-top-1 border-bottom-none surface-border mt-auto"/>

                                                <div className="formgroup-inline hide">
                                                    <BusquedaAPata alumno={alumno} handlePrenda={handlePrenda} />
                                                    <Button icon="pi pi-qrcode" className="mr-2 mb-2" onClick={() => handleScanner(alumno)}></Button>
                                                </div>*/}
                                            </div>
                                        </div>
                                    </div>
                                })
                            }
                        </div>



                        <div className=" surface-100 text-right">
                            <div id='btnSiguiente2Flotante'>
                                <Button
                                    label="Regresar"
                                    icon='pi pi-arrow-circle-left'
                                    className="p-button-rounded mr-2"
                                    onClick={() => handleRegresarAPendientes()} />
                            </div>
                            <div id='btnSiguiente' >
                                <Button
                                    label="Siguiente"
                                    icon='pi pi-arrow-circle-right'
                                    className="p-button-rounded"
                                    onClick={() => handleCapturaIdentificacion()} />
                            </div>
                        </div>


                    </div>




                }

                {formIndentificacion &&
                    <div className="col-12">
                        <EvidenciasTemplate />

                        <div className="csetConfirmScannerol-12">
                            <div className=" surface-100 text-right">
                                <div id='btnSiguiente2Flotante'>
                                    <Button
                                        label="Regresar"
                                        icon='pi pi-arrow-circle-left'
                                        className="p-button-rounded mr-2 "
                                        onClick={() => handleRegresarASeleccionPrenda()} />
                                </div>
                                {/* <div id='btnSiguiente' >
                                    <Button
                                        label="Siguiente"
                                        icon='pi pi-arrow-circle-right'
                                        className="p-button-rounded"
                                        onClick={() => handleClick_siguienteIdentificacion()} />
                                </div> */}
                                <div id='btnSiguiente' >
                                    <Button
                                        label="Finalizar"
                                        disabled={loading}
                                        icon={(loading ? 'pi pi-spin pi-spinner' : 'pi pi-check')}
                                        className="p-button-rounded "
                                        onClick={() => handleConfirmarFinalizar()} />
                                </div>
                            </div>
                        </div>

                    </div>}

                {/* {formFirma &&
                    <div className="col-12">
                        <div className="col-12  p-3">
                            <div className={`shadow-2 border-round surface-card mb-3 h-full flex-column justify-content-between flex`}>
                                <div className="p-4">
                                    <span className={`inline-flex border-circle align-items-center justify-content-center bg-gray-100 mr-3`} style={{ 'width': "48px", 'height': "48px", 'borderRadius': "10px" }}>
                                        <i className={`pi pi-pencil text-xl text-gray-600`}></i>
                                    </span>
                                    <span className="text-900 font-medium text-2xl">
                                        Firma electrónica
                                    </span>
                                </div>

                                <div className='col-12' style={{ 'height': "310px" }}>
                                    <canvas
                                        ref={canvasRef}
                                        id="drawing-area"
                                        onMouseDown={startDraw}
                                        onMouseUp={stopDraw}
                                        onMouseMove={draw}

                                        onTouchStart={startDraw}
                                        onTouchMove={draw}
                                        onTouchEnd={stopDraw}
                                        style={{ "border": "1px solid black" }}>
                                    </canvas>
                                </div>

                                <div className='col.12' style={{ display: 'flex' }}>
                                    <div className="col-6 text-left">
                                        <Button label="Limpiar" className="p-button-outlined p-button-rounded mr-2 mb-2" onClick={() => clear()} />
                                    </div>

                                </div>


                                <div className=" surface-100 text-right">
                                    <div id='btnSiguiente2Flotante'>
                                        <Button
                                        label="Regresar"
                                        icon='pi pi-arrow-circle-left'
                                        className="p-button-rounded mr-2"
                                        onClick={() => handleRegresarACargarComprobante()} />
                                    </div>
                                    <div id='btnSiguiente' >
                                        <Button
                                        label="Finalizar"
                                        disabled={loading}
                                        icon={(loading ? 'pi pi-spin pi-spinner' : 'pi pi-check')}
                                        className="p-button-rounded "
                                        onClick={() => firmaValida() ? handleConfirmarFinalizar() : mensajeOmicion()} />
                                    </div>
                                </div>
                            
                            </div>
                        </div>
                    </div>} */}
            </div>

            <Dialog header="Confirmación" resizable={false} draggable={false} visible={displayConfirmation} onHide={() => setDisplayConfirmation(false)} style={{ width: '400px' }} modal className="p-fluid" footer={confirmationDialogFooter}>
                <div className="flex align-items-center justify-content-center">
                    <span>
                        ¿Cuenta con identificación oficial?
                    </span>
                </div>
            </Dialog>

            <Dialog header="AVISO" visible={aviso} draggable={false} closable={false} resizable={false} onHide={() => handlerRedirect} style={{ width: '400px' }} modal className="p-fluid" footer={basicDialogFooter}>
                {guardadoExitoso === true ?

                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '15px' }}>
                        <img src='assets/layout/images/check_verde.png' style={{ width: '40px', marginRight: '15px' }} />
                        <p style={{ color: '#166d44', textTransform: 'uppercase', fontSize: '18px', fontWeight: 'bold', textAlign: 'center' }}>{message && message}</p>
                    </div>
                    :
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '15px' }}>
                        <img src='assets/layout/images/tache_rojo.png' style={{ width: '40px', marginRight: '15px' }} />
                        <p style={{ color: '#9b2f3e', fontSize: '15px', textAlign: 'center' }}>{message && message}</p>
                    </div>
                }

            </Dialog>

            <Dialog header="Entrega no disponible" visible={displayDialogMensaje} draggable={false} resizable={false} closable={false} style={{ width: '400px' }} modal className="p-fluid" footer={basicDialogFooterMensaje}>
                <div className='m-3'>
                    <h5>Al menos un alumno no cuenta con prendas disponibles.</h5>
                </div>
            </Dialog>

            <Dialog header="Aviso de error" visible={avisoe} onHide={() => navigate("/pendientes")} style={{ width: '400px' }} modal className="p-fluid" footer={basicDialogFooter2}>
                <p>{messagee && messagee}</p>
            </Dialog>

            <Dialog header="Confirmación" draggable={false} resizable={false} visible={confirm_cancelar} onHide={() => setConfirm_cancelar(false)} style={{ width: '400px' }} modal className="p-fluid" footer={confirmationCancelarDialogFooter}>
                <div className="flex align-items-center justify-content-center">
                    <span>
                        ¿Está seguro de cancelar la entrega?<br />
                        <small>Cancelaras todas las entregas seleccionadas</small>
                    </span>
                </div>
            </Dialog>

            <Dialog header="Scanner QR" visible={confirmScanner} onHide={() => setConfirmScanner(false)} style={{ width: '400px' }} modal className="p-fluid" >
                <div className="flex align-items-center justify-content-center">
                    <span>
                        {confirmScanner && <Scanner alumno={alumno} handlePrenda={handlePrenda} />}
                    </span>
                </div>
            </Dialog>

            <Dialog header="CONFIRMACIÓN" resizable={false} draggable={false} closable={false} visible={confirmarFinalizar} onHide={() => setConfirmarFinalizar(false)} style={{ width: '400px' }} modal className="p-fluid" footer={confirmationFinalizarDialogFooter}>
                <div className="flex align-items-center justify-content-center pl-3 pr-3">
                    <label>¿Está seguro de finalizar este proceso de entrega del ciclo <label style={{ fontWeight: '700' }}>{nameCiclo !== null && nameCiclo}</label>?</label>
                </div>
            </Dialog>

            <Dialog header="EDITAR TUTOR" id='modalCancelacion' blockScroll={true} resizable={false} draggable={false} visible={editarTutor} style={{ width: '95vw' }} modal onHide={modalonhiden2}>
                <form onSubmit={handleConfirmarEditarTutor} className="col-12">
                    <div className="row">
                        <label style={{ textAlign: 'right', color: 'red' }}>* Campos obligatorios</label>
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-6">
                                <label htmlFor="nombre"><b style={{ marginRight: '5px', color: 'red' }}>*</b>Nombre(s):</label>
                                <InputText id="nombre" name="nombre" type="text" value={formTutor.nombre} onChange={handleChange_Tutor} autoFocus className={errors_nuevo_tutor.nombre && 'p-invalid'} />
                                {errors_nuevo_tutor.nombre && <small className="p-error">{errors_nuevo_tutor.nombre}</small>}
                            </div>

                            <div className="field col-12 md:col-6">
                                <label htmlFor="apellido1"><b style={{ marginRight: '5px', color: 'red' }}>*</b>Primer apellido:</label>
                                <InputText id="apellido1" name="apellido1" type="text" value={formTutor.apellido1} onChange={handleChange_Tutor} className={errors_nuevo_tutor.apellido1 && 'p-invalid'} />
                                {errors_nuevo_tutor.apellido1 && <small className="p-error">{errors_nuevo_tutor.apellido1}</small>}
                            </div>

                            <div className="field col-12 md:col-6">
                                <label htmlFor="apellido2">Segundo apellido:</label>
                                <InputText id="apellido2" name="apellido2" type="text" value={formTutor.apellido2} onChange={handleChange_Tutor} className={errors_nuevo_tutor.apellido2 && 'p-invalid'} />
                                {errors_nuevo_tutor.apellido2 && <small className="p-error">{errors_nuevo_tutor.apellido2}</small>}
                            </div>

                            {/*   <div className="field col-12 md:col-6">
                                <label htmlFor="idTipoTutor"><b style={{ marginRight: '5px', color: 'red' }}>*</b>Tipo tutor:</label>
                                <Dropdown id="idTipoTutor" name="idTipoTutor" type="text" value={formTutor.idTipoTutor} onChange={handleChange_Tutor} options={lstTipoTutor} optionLabel='TipoTutor' optionValue='IdTipoTutor' className={errors_nuevo_tutor.idTipoTutor && 'p-invalid'} />
                                {errors_nuevo_tutor.idTipoTutor && <small className="p-error">{errors_nuevo_tutor.idTipoTutor}</small>}
                            </div> */}
                        </div>

                        <div className="px-4 py-3 surface-100 text-right">
                            {loadingEditarTutor && <div><Loader /></div>}
                            <Button type="submit" disabled={loadingEditarTutor} icon={(loadingEditarTutor ? 'pi pi-spin pi-spinner' : 'pi pi-check')} value="Enviar" label="Guardar" className="mr" align="right"></Button>
                        </div>
                    </div>
                </form>
            </Dialog>
        </>
    )
}

export default MultientregaScanner;
